import React from 'react';
import PropTypes from 'prop-types';

import {
  FieldValue
} from '../../../packages/detail-panel';

import {
  ResourceCard,
  ResourceRef,
} from '../../resource';

import {
  BucketIcon,
} from "../../aws";

import { 
  fmtIso8601AsLocalDateTime,
  fmtS3ConsoleLink,
} from '../../utils/formatters';

const handleGoToBucket = (bucket) => {
  window.open(fmtS3ConsoleLink(bucket),"_blank");
};

export default function StreamCard(props) {

  const { resource } = props;

  if(!resource) return(null); 
  
  const actions=[];

  if(resource.StorageConfiguration?.TargetS3Uri) {
    actions.push({ 
      name: `View streamed objects...`,
      icon: BucketIcon,
      onClick: () => handleGoToBucket(resource.StorageConfiguration?.TargetS3Uri),
    });
  }

  const fields=[
    { section: "Details", fields: [
      { name: "ResourceId", label: "ID", component: FieldValue, options: { maxLength: 40 } }, 
      { name: "ClientAccountId", label: "Client", component: ResourceRef, options: { type: 'Client' } },
      { name: "StreamConfiguration.StreamArn", label: "Stream ARN", component: FieldValue, options: { maxLength: 40 } },
      { name: "StreamConfiguration.ShardCount", label: "Shards" },
      { name: "StreamConfiguration.RetentionPeriodHours", label: "Retention" },
      { name: "StackCreated", label: "Created", formatter: fmtIso8601AsLocalDateTime },
      { name: "StackUpdated", label: "Updated", formatter: fmtIso8601AsLocalDateTime },
    ]},
    { section: "Storage", fields: [
      { name: "StorageConfiguration.LandingZoneId", label: "Landing Zone" },
      { name: "StorageConfiguration.TargetPrefix", label: "Prefix" },
      { name: "StorageConfiguration.TargetS3Uri", label: "Location" },
      { name: "StorageConfiguration.WriteIntervalInSeconds", label: "Write Interval" },
      { name: "StorageConfiguration.WriteSizeInMBs", label: "Write Size" },
    ]},
  ];

  return (
    <ResourceCard 
      resource={resource} 
      fields={fields} 
      stack 
      dashboard 
      actions={actions}/>
  );
}

StreamCard.propTypes = {
  resource: PropTypes.object.isRequired,
};

StreamCard.defaultProps = {
};
